import React from 'react';
import { Link, NavLink } from "react-router-dom";
// import cta1 from "../../../assets/img/cta1.png";
// import cta2 from "../../../assets/img/cta2.png";
import cta1 from "../../../assets/img/work-one.jpg";
import cta2 from "../../../assets/img/work-two.jpg";
import ctadot1 from "../../../assets/img/cta-dot1.svg";
import ctadot2 from "../../../assets/img/cta-dot2.svg";
import { fadeInLeft, fadeInRight } from 'react-animations';
import Radium, { StyleRoot } from 'radium';
import taskdeapp from '../../../assets/img/taskde-app.png';
import appstore from '../../../assets/img/app-store.png';
import playstore from '../../../assets/img/google-play.png';

const styles = {
    fadeInLeft: {
        animation: 'x 3s',
        animationName: Radium.keyframes(fadeInLeft, 'fadeInLeft')
    },
    fadeInRight: {
        animation: 'x 3s',
        animationName: Radium.keyframes(fadeInRight, 'fadeInRight')
    }
}

const CallToAction = () => {
    return (
        <React.Fragment>
            <section id="cta" className="cta" data-aos="fade-up" data-aos-duration="2000">
                <div className="container">

                    <div className="row g-5">

                        <div className="col-xl-6 col-lg-12 col-md-12 col-12 content d-flex flex-column justify-content-center order-last order-md-last">
                            <h3>Work <strong>when</strong> you want, doing <strong>what</strong> you want.</h3>
                            <ul className="workculture">
                                <li>
                                    <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3.59H16.75V2.66a.75.75,0,1,0-1.5,0v.93H8.75V2.66a.75.75,0,1,0-1.5,0v.93H4A2.75,2.75,0,0,0,1.25,6.34v13A2.75,2.75,0,0,0,4,22.09H20a2.75,2.75,0,0,0,2.75-2.75v-13A2.75,2.75,0,0,0,20,3.59ZM4,5.09H7.25V6.16a.75.75,0,0,0,1.5,0V5.09h6.5V6.16a.75.75,0,0,0,1.5,0V5.09H20a1.25,1.25,0,0,1,1.25,1.25V8.59H2.75V6.34A1.25,1.25,0,0,1,4,5.09ZM21.25,19.34A1.25,1.25,0,0,1,20,20.59H4a1.25,1.25,0,0,1-1.25-1.25V10.09h18.5Z"></path><path d="M8,16.84a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,8,16.84Zm0-3.5a1,1,0,1,1-1,1A1,1,0,0,1,8,13.34Z"></path></svg>
                                    Earn extra income on your time schedule
                                </li>
                                <li>
                                    <svg width="24" height="24" viewBox="0 0 24 24"><path d="m22.2 3.43a.76.76 0 0 0 -.68-.66c-.25 0-6.08-.48-7.35 4a8.48 8.48 0 0 0 -.1 2.93 3.4 3.4 0 0 0 -1.17.55l-.05-1.35a3.64 3.64 0 0 0 -3.47-3.52h-.05c-.17-.03-4.22-.38-6.33 2.1-1.18 1.36-1.51 3.24-1 5.6a.76.76 0 0 0 .6.58 9.59 9.59 0 0 0 1.77.17 5.28 5.28 0 0 0 5.44-4.52 21.08 21.08 0 0 0 .19-2.31 2.15 2.15 0 0 1 1.32 1.9l.15 4.19.27 7.42a.74.74 0 0 0 .74.72.74.74 0 0 0 .72-.78l-.2-7.4a1.91 1.91 0 0 1 1.91-2 9.89 9.89 0 0 0 1.66.16 5.33 5.33 0 0 0 3.78-1.36c2.34-2.21 1.87-6.25 1.85-6.42zm-13.86 5.57c-.58 2.55-2.21 3.61-5 3.24a4.42 4.42 0 0 1 .75-3.79c1.18-1.36 3.33-1.6 4.42-1.62a19.24 19.24 0 0 1 -.17 2.17zm11-.27a4.41 4.41 0 0 1 -3.74.88 7.42 7.42 0 0 1 0-2.51c.72-2.52 3.78-2.85 5.13-2.88.04 1.11-.09 3.3-1.41 4.54z"></path></svg>
                                    Grow your business, client-base, or even just your skills
                                </li>
                                <li>
                                    <i className="bi bi-currency-rupee"></i> Access thousands of job opportunities, for free
                                </li>
                            </ul>
                            <div>
                                <div className="text-center text-lg-start">
                                    <NavLink to="/signup" className="btn-read-more scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                                        <span>Earn money as a Seller</span>
                                        <i className="bi bi-arrow-right"></i>
                                    </NavLink>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-12 col-md-12 col-12 order-first order-md-first d-flex align-items-center">
                            <div className='img'>
                                <div className="img-main">
                                    <img src={cta2} alt="" className="img-fluid" />
                                </div>
                                <div className='img-dot1'>
                                    <img src={ctadot1} alt="" className='img-fluid' />
                                </div>
                                <div className='img-dot2'>
                                    <img src={ctadot2} alt="" className='img-fluid' />
                                </div>
                                <div className="img-absolute">
                                    <img src={cta1} alt="" className="img-fluid" />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <section>
                <div className='container'>
                    <div className='app-download'>
                        <div className="row gy-4">

                            <div className="col-lg-6 order-2 order-lg-1" style={styles.fadeInRight}>
                                <div className="content">
                                    <div className="container-inner mt-5">
                                        <div className="list column-2 text-description">
                                            <h3 className="blue">On the move?</h3>
                                            <p>Download the Taskde App and get the tasks you need completed with just a tap of the button. You can also browse available tasks and earn money wherever you go!</p>

                                        </div>
                                        <div className="list column-2 smart-phones">
                                            <h3 className='seller_fs'>For Seller</h3>
                                            <div className='link_flex'>
                                                <Link to='https://apps.apple.com/in/app/taskde-seller-app/id6445817925' target='_blank'>
                                                    <img alt="" src={appstore} className='img-fluid' />
                                                </Link>
                                                <Link to='https://play.google.com/store/apps/details?id=com.taskde.taskdeseller' target='_blank'>
                                                    <img alt="" src={playstore} className='img-fluid' />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="list column-2 smart-phones">
                                            <h3 className='buyer_fs'>For Buyer</h3>
                                            <div className='link_flex'>
                                                <Link to='https://apps.apple.com/in/app/taskde-buyer-app/id6445815247' target='_blank'>
                                                    <img alt="" src={appstore} className='img-fluid' />
                                                </Link>
                                                <Link to='https://play.google.com/store/apps/details?id=com.taskde.taskdebuyer' target='_blank'>
                                                    <img alt="" src={playstore} className='img-fluid' />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6' style={styles.fadeInLeft}>
                                <div className="apps-badges">
                                    <img alt="" src={taskdeapp} className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    )
}

export default CallToAction;